import React from 'react'
// import PropTypes from 'prop-types'

const propTypes = {}

const defaultProps = {}

function SearchLoadingIndicator() {
  return <div className="content"> Loading search results... </div>
}

SearchLoadingIndicator.propTypes = propTypes

SearchLoadingIndicator.defaultProps = defaultProps

export default SearchLoadingIndicator
